"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dispatch_1 = require("./dispatch");
var effects_1 = require("./effects");
var corePlugins = [
    dispatch_1.default,
    effects_1.default,
];
exports.default = corePlugins;
//# sourceMappingURL=index.js.map